import { useState } from 'react'
import axios from 'axios'
import { Modal, message, Button, AutoComplete } from 'antd'
import MyInput from '../../../../components/forms/input'
import MyIcon from '../../../../components/general/icon'

const AddRecipeIngredient = (props) => {
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})
  const [ingredientOptions, setIngredientOptions] = useState([]) // 存储联想数据

  const handleSearch = async (keyword) => {
    if (!keyword) {
      setIngredientOptions([])
      return
    }
    
    try {
      const response = await axios.post('/admin/user/basic_ingredients/search', {
        keywords: keyword
      })
      setIngredientOptions(response.data.map(item => ({ value: item, label: item })))
    } catch (error) {
      console.error('搜索失败:', error)
    }
  }

  const handleSubmit = async () => {
    setErrorMsg({})
    if (!formValue.ingredient_name) {
      setErrorMsg({ ingredientNameEmpty: '食材名称不能为空' })
      return false
    }
    if (!formValue.dosage) {
      setErrorMsg({ dosageEmpty: '用量不能为空' })
      return false
    }

    try {
      const response = await axios.post('/admin/user/recipe_ingredient/add', {
        ingredient_name: formValue.ingredient_name,
        dosage: Number(formValue.dosage),
        sort: Number(formValue.sort),
        recipe_oid: props.data.recipeOid
      })

      if (response.errcode === 0) {
        message.success('添加成功！')
        props.getRecipeIngredientData()
        return true
      } else if (response.errcode === 1) {
        setErrorMsg({ ingredientNameError: response.msg })
        return false
      }
    } catch (error) {
      console.error('请求失败，错误信息为：', error)
      return false
    }
  }

  const handleOk = async () => {
    const isOk = await handleSubmit()
    if (isOk !== false) {
      handleCancel()
    }
  }

  const handleNext = () => {
    handleSubmit()
    setFormValue({})
    setIngredientOptions([])
  }

  const handleCancel = () => {
    setErrorMsg({})
    setFormValue({})
    props.isCancel()
  }

  return (
    <Modal
      destroyOnClose={true}
      title="添加食材"
      width='500px'
      open={props.isOpen}
      onCancel={handleCancel}
      maskClosable={false}
      footer={[
        <Button key='cancel' onClick={handleCancel}>取消</Button>,
        <Button key='submit' onClick={handleNext}>提交并添加下一条</Button>,
        <Button key='isOk' type="primary" onClick={handleOk}>添加</Button>
      ]}>
      
      <div className="form-box">
        <label>
          食材
          <span style={{ color: '#ae2a19' }}> *</span>
        </label>
        <AutoComplete
          style={{ height: '40px', width: '100%' }}
          placeholder="输入食材名称"
          options={ingredientOptions}
          onSearch={handleSearch}
          onChange={(value) => setFormValue({...formValue, ingredient_name: value})}
          filterOption={false}
          allowClear={true}
          value={formValue.ingredient_name}
        />
        {errorMsg.ingredientNameEmpty || errorMsg.ingredientNameError ? (
          <div className="form-errormsg">
            <span><MyIcon name='jinggao' /></span> 
            <p>{errorMsg.ingredientNameEmpty || errorMsg.ingredientNameError}</p>
          </div>
        ) : null}
      </div>

      <MyInput
        type='number'
        id="dosage"
        required
        label='用量'
        value={formValue.dosage}
        onChange={setFormValue}
        styles={{ width: '100px' }}
        min={0}
        max={1000}
        errorMsg={errorMsg.dosageEmpty}
      />

      <MyInput
        type='number'
        id="sort"
        label='排序'
        value={formValue.sort}
        onChange={setFormValue}
        styles={{ width: '60px' }}
        min={0}
        max={1000}
      />
    </Modal>
  )
}

export default AddRecipeIngredient
